import React from 'react';
import PropTypes from 'prop-types';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { popularCitiesResourceDefinition } from './utils/queryDefinitions';
import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';

export default function BreederProfilePopularCities({ breedName, breedId }) {
  const { value: citiesData } = useResourceQuery(
    popularCitiesResourceDefinition(breedId)
  );

  return (
    <BreederProfileLocationLinksGroup
      breedName={breedName}
      linksData={citiesData}
      header={`Find ${breedName} puppies by city`}
      wideLayout
      limit={50}
    />
  );
}

BreederProfilePopularCities.propTypes = {
  breedName: PropTypes.string.isRequired,
  breedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
